import { render, staticRenderFns } from "./PrivilegeSelectionDialogForAccessToken.vue?vue&type=template&id=9e81670a&scoped=true"
import script from "./PrivilegeSelectionDialogForAccessToken.vue?vue&type=script&lang=js"
export * from "./PrivilegeSelectionDialogForAccessToken.vue?vue&type=script&lang=js"
import style0 from "./PrivilegeSelectionDialogForAccessToken.vue?vue&type=style&index=0&id=9e81670a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e81670a",
  null
  
)

export default component.exports